import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';

const metrics = [
  {
    value: '+100K',
    label: 'Seguidores de Yeraldine Marrero',
    subtitle: 'Instagram',
  },
  {
    value: '+90K',
    label: 'Seguidores de TNO Network',
    subtitle: 'En todas sus redes',
  },
];

const Alcance = () => {
  const theme = useTheme();

  return (
    <Box>
      <Typography
        sx={{ textTransform: 'uppercase', fontWeight: 600 }}
        gutterBottom
        color="primary"
        align="center"
      >
        Alcance
      </Typography>
      <Typography variant="h5" fontWeight={700} align="center" gutterBottom>
        Audiencia que conecta con tu marca
      </Typography>
      <Grid container spacing={3} sx={{ mt: 2 }}>
        {metrics.map((item, i) => (
          <Grid item xs={12} md={6} key={i}>
            <Box
              component={Card}
              variant="outlined"
              sx={{
                borderLeft: 4,
                borderColor: theme.palette.primary.main,
                height: '100%',
              }}
            >
              <CardContent>
                <Typography variant="h4" fontWeight={900} color="primary" gutterBottom>
                  {item.value}
                </Typography>
                <Typography variant="h6" fontWeight={600} gutterBottom>
                  {item.label}
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  {item.subtitle}
                </Typography>
              </CardContent>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Alcance;
